import React, { useState, useEffect } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import ProfileNavbar from "../Component/ProfileNavbar";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Import API URL and image URL
import axios from "axios";
import defaultuser from "../Component/img/user.png"; // Default image if no profile image is available
import ChatComponent from "../Component/ChatComponent";

const Message = () => {
  const [acceptedConnections, setAcceptedConnections] = useState([]);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null); // State to store selected connection ID
  const user_id = localStorage.getItem("visitor_id"); // Get the visitor ID from localStorage

  // Fetch accepted connections from the API
  useEffect(() => {
    const fetchAcceptedConnections = async () => {
      try {
        const response = await axios.get(`${BASE_URL}accepted-connections`, {
          params: { user_id }, // Pass the user_id to the API
        });

        // Log the response object to the console
        console.log("API Response:", response);

        // Check if AcceptedConnections exist and update the state
        if (response.data.AcceptedConnections) {
          setAcceptedConnections(response.data.AcceptedConnections); // Update state with AcceptedConnections
        }
      } catch (error) {
        console.error("Error fetching accepted connections:", error);
      }
    };

    fetchAcceptedConnections();
  }, [user_id]); // Only re-fetch when user_id changes

  // Handle click on connection and set the selected connection ID
  const handleConnectionClick = (id) => {
    setSelectedConnectionId(id); // Update the selected connection ID
  };

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>

            <div className="col-md-3">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="text-start hedng">Messages</h2>

                {/* Events list below calendar */}
                <div className="row mt-4">
                  <div className="col-md-12">
                    <ul className="list-group">
                      <h5 className="ft-event mb-2">Accepted Connections Request</h5>
                      {acceptedConnections.length > 0 ? (
                        acceptedConnections.map((connection) => (
                          <li
                            key={connection.id}
                            className="list-group-item mb-2 rounded ptyah"
                            onClick={() => handleConnectionClick(connection.id)} // On click, set the selected connection
                          >
                            <div className="d-flex">
                              <div>
                                <img
                                  src={
                                    connection.profile_image
                                      ? `${IMAGE_URL}/${connection.profile_image}`
                                      : defaultuser
                                  }
                                  className="img-fluid maxconimgmsg"
                                  alt="Profile"
                                />
                              </div>
                              <div className="ms-2 oksa ">
                                <strong>{connection.name}</strong>
                                <div className="oksa text-muted">{connection.designation}</div>
                              </div>
                            </div>
                          </li>
                        ))
                      ) : (
                        <div className="text-muted">No accepted connections found.</div>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              {/* <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <div className="row">
                  <div className="col-md-12">
                    <div className="calendar-container">
                       
                      <ChatComponent selectedConnectionId={selectedConnectionId} />  
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Message;
